import * as React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import AttachmentIcon from "@mui/icons-material/Attachment";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import clsx from "clsx";
import moment from "moment";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Card from "@mui/material/Card";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axiosRequest from "../../api/axios";
import axiosRequestProd from "../../api/axiosprod";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import TableStyle from "../Helpers/TableStyle";
import { fontStyle } from "@mui/system";
import Header from "../Reusables/Header";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import OutlinedInput from "@mui/material/OutlinedInput";
// import Autocomplete from "@mui/material/Autocomplete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { WrapText } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Slide from "@mui/material/Slide";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
// import MultiSelect from "../Helpers/Multiselect";
// import LoadingButton from "@mui/lab/LoadingButton";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },

  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};
const MenuProps1 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles1 = makeStyles(TableStyle);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles({
  tableRow: {
    height: 30,
  },
  tableCell: {
    padding: "0px 16px",
  },
});
function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}
const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#b53622",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#b53622",
    },
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.secondary.main,
    // color: theme.palette.common.white,
    paddingLeft: 10,
    paddingRight: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   // hide last border
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="admin-table-sticky">
      <TableRow
        sx={{
          "& th": {
            color: "#393b3a",
            backgroundColor: "#ebedeb",
            fontWeight: "bold",
            fontSize: "12px",
          },
        }}
      >
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="left"
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              style={{
                width: headCell.width,
                maxHeight: "60px",
                minHeight: "30px",
              }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
};
const MultiSelectRBM = ({
  items,
  selectedValues,
  label,
  limitTags,
  placeholder,
  selectAllLabel,
  noOptionsText,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };


  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option) => option.rbmcode === "Select All")) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
    console.log(selectedOptions, "alksjd");
    // let rbm_reset=[]
    // if(selectedOptions.length>0){
    //   if(selectedOptions.find(object => object['rbmcode'] === 'Select All')){
    //     setAbmcodesListReset(rbmcodesListReset)
    //   }
    //   else{
    //     for(let item of rows){
    //     for(let selected of selectedOptions){
    //       if(item['rbmcode'] === selected['rbmcode']){
    //         if(!rbm_reset.find(object => object['rbmcode'] === item['rbmcode'])){
    //           rbm_reset.push(item)
    //         }
    //       }
    //     }
    //     }
    //     setAbmcodesListReset(rbm_reset)

    //   }
    // }
    //   for(let item of rows){
    //     if(values.includes(item['teamcode'])){
    //       if(!rbm_reset.find(object => object['rbmcode'] === row['rbmcode'])){
    //         rbm_reset.push(row)
    //       }
    //     }
    // }
    // setAbmcodesListReset
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.rbmcode === "Select All" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = (params) => (
    <TextField
      variant="outlined"
      size="small"
      {...params}
      label={label}
      placeholder={placeholder}
    />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.rbmcode === anotherOption.rbmcode;
  const filter = createFilterOptions();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      className="teamresetclass"
      options={items}
      limitTags={limitTags}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [
          { label: selectAllLabel, rbmcode: "Select All", rbmname: "" },
          ...filtered,
        ];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelectRBM.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};
const MultiSelectABM = ({
  items,
  selectedValues,
  label,
  limitTags,
  placeholder,
  selectAllLabel,
  noOptionsText,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option) => option.abmcode === "Select All")) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
    console.log(selectedOptions, "alksjd");
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.abmcode === "Select All" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = (params) => (
    <TextField
      variant="outlined"
      size="small"
      {...params}
      label={label}
      placeholder={placeholder}
    />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.abmcode === anotherOption.abmcode;
  const filter = createFilterOptions();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      className="teamresetclass"
      options={items}
      limitTags={limitTags}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [
          { label: "Select All", abmcode: "Select All", abmname: "" },
          ...filtered,
        ];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelectABM.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};
const MultiSelectREPHQ = ({
  items,
  selectedValues,
  label,
  limitTags,
  placeholder,
  selectAllLabel,
  noOptionsText,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option) => option.repcode === "Select All")) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
    console.log(selectedOptions, "alksjd");
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.repcode === "Select All" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = (params) => (
    <TextField
      variant="outlined"
      size="small"
      {...params}
      label={label}
      placeholder={placeholder}
    />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.repcode === anotherOption.repcode;
  const filter = createFilterOptions();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      className="teamresetclass"
      options={items}
      limitTags={limitTags}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [
          { label: selectAllLabel, repcode: "Select All", repname: "" },
          ...filtered,
        ];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelectREPHQ.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};
const MultiSelectQuarter = ({
  items,
  selectedValues,
  label,
  limitTags,
  placeholder,
  selectAllLabel,
  noOptionsText,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option) => option.quarter === "Select All")) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
    console.log(selectedOptions, "alksjd");
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.quarter === "Select All" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = (params) => (
    <TextField
      variant="outlined"
      size="small"
      {...params}
      label={label}
      placeholder={placeholder}
    />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.quarter === anotherOption.quarter;
  const filter = createFilterOptions();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      className="teamresetclass"
      options={items}
      limitTags={limitTags}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [{ label: "Select All", quarter: "Select All" }, ...filtered];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelectQuarter.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};
const MultiSelectYear = ({
  items,
  selectedValues,
  label,
  limitTags,
  placeholder,
  selectAllLabel,
  noOptionsText,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const allSelected = items.length === selectedValues.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option) => option.year === "Select All")) {
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
    console.log(selectedOptions, "alksjd");
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.year === "Select All" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = (params) => (
    <TextField
      variant="outlined"
      size="small"
      {...params}
      label={label}
      placeholder={placeholder}
    />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.year === anotherOption.year;
  const filter = createFilterOptions();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      className="teamresetclass"
      options={items}
      limitTags={limitTags}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [{ label: selectAllLabel, year: "Select All" }, ...filtered];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelectYear.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
};
export default function EnhancedTable() {
  const { table } = useParams();
  const classes = useStyles1();

  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isFilePickedTeams, setIsFilePickedTeams] = useState(false);
  const [selectedFileNameTeams, setselectedFileNameTeams] = React.useState("");
  const [selectedFileName, setselectedFileName] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [order, setOrder] = React.useState("asc");
  const [editingIndex, setEditingIndex] = React.useState();
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [headcells, setHeadCells] = React.useState([]);
  const [appheadcells, setAppHeadCells] = React.useState([]);
  const [rbmappheadcells, setRbmAppHeadCells] = React.useState([]);
  const [approws, setAppRows] = React.useState([]);
  const [rbmapprows, setRbmAppRows] = React.useState([]);
  const [rbmtemplate, setRbmTemplate] = React.useState([]);
  const [abmtemplate, setAbmTemplate] = React.useState([]);
  const [rephqtemplate, setRephqTemplate] = React.useState([]);
  const [rbmtemplateheadcells, setRbmTemplateHeadCells] = React.useState([]);
  const [abmtemplateheadcells, setAbmTemplateHeadCells] = React.useState([]);
  const [rephqtemplateheadcells, setRephqTemplateHeadCells] = React.useState(
    []
  );
  const [changedStatusId, setchangedStatusId] = React.useState('');
  const [changedStatusRBMId, setchangedStatusRBMId] = React.useState('');
  const [backuprows, setBackupRows] = React.useState([]);
  const [file, setFile] = React.useState("");
  const [fileTeams, setFileTeams] = React.useState("");
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderBackup, setLoaderBackup] = useState(false);
  const [loaderUpload, setloaderUpload] = useState(false);
  const [loaderUploadTeams, setloaderUploadTeams] = useState(false);
  const [loaderDownload, setloaderDownload] = useState(false);
  const [loaderDownloadTrig, setloaderDownloadTrig] = useState(false);
  const [selectedEditRow, setSelectedEditRow] = React.useState({});
  const [openDel, setOpenDel] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = React.useState(0);
  const [effStartDate, setEffStartDate] = React.useState(null);
  const [effEndDate, setEffendDate] = React.useState(null);
  const [newUser, setNewUser] = React.useState({});
  const [LoaderSaveUser, setLoaderSaveUser] = React.useState(false);
  const [editReady, setEditReady] = React.useState(false);
  const [orgRows, setOrgRows] = React.useState([]);
  const [newUserRole, setNewUserRole] = React.useState("");
  const [newTeamsData, setNewTeamsData] = React.useState("buhead");
  const [duplicates, setDuplicates] = React.useState(false);
  const [loaderDownloadDup, setLoaderDownloadDup] = React.useState(false);
  const [loaderTeams, setLoaderTeams] = React.useState(false);
  const [loaderTeams1, setLoaderTeams1] = React.useState(false);
  const [loaderTeams2, setLoaderTeams2] = React.useState(false);
  const [loaderReset, setLoaderReset] = React.useState(false);
  const [loaderStatusApproval, setloaderStatusApproval] = React.useState(false);
  const [loaderStatusRBMApproval, setloaderStatusRBMApproval] = React.useState(false);
  const [TabValue, setTabValue] = React.useState(0);
  const [TabValueName, setTabValueName] = React.useState("Approval");
  const [openTeams, setOpenTeams] = React.useState(false);
  const [openTriggerUp, setOpenTriggerUp] = React.useState(false);
  const [TabValueTemplate, setTabValueTemplate] = React.useState(0);
  const [TabValueTemplateName, setTabValueTemplateName] =
    React.useState("BUH TEMPLATE");
  const [selectedTrigger, setSelectedTrigger] = useState([]);
  const options = ["T1", "T2", "T3", "T7", "TD", "TR","T5"];
  const [openReset, setOpenReset] = React.useState(false);
  const [teamsListReset, setTeamsListReset] = React.useState([]);
  const [rbmcodesListReset, setRbmcodesListReset] = React.useState([]);
  const [abmcodesListReset, setAbmcodesListReset] = React.useState([]);
  const [repcodesListReset, setRepcodesListReset] = React.useState([]);
  const [quartersListReset, setQuartersListReset] = React.useState([]);
  const [yearsListReset, setYearsListReset] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedSource, setSelectedSource] = useState("");
  const [loadingAPI, setLoadingAPI] = useState(false);
  // Dummy team list (Replace with API data if needed)
  const teams = ["T1","T2","T3","T7","T5","TR"];
  const sources = ["BU Head", "RBM"];

  // Open/Close Modal Handlers
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Handle Multi-Select Change
  const handleChangeTeams = (event) => {
    setSelectedTeams(event.target.value);
  };
  const handleSourceChange = (event) => setSelectedSource(event.target.value);

// API Call Function
const handleApiCall = async() => {
  console.log("Selected Teams:", selectedTeams);
  const postData = {
    "teamcode": selectedTeams,
    "source_name": selectedSource
}
  await axiosRequest({
    url: "rbm_app/upsertdatabuheadorrbm/",
    method: "POST",
    data: postData,
    headers: api_headers,
  }).then((data) => {
    if (data.status === 200) {
      handleSnackBar("Data updated successfully", "success");
      setLoadingAPI(false);
    } else {
      handleSnackBar("Something went wrong", "error");
      setLoadingAPI(false);
    }
  });
  // Make API call here
  handleCloseModal();
};
  const isAllSelected =

    options.length > 0 && selectedTrigger.length === options.length;

  const handleChangeTrigger = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelectedTrigger(
        selectedTrigger.length === options.length ? [] : options
      );
      return;
    }
    setSelectedTrigger(value);
  };

  const statusApproval = async(data) =>{
    setloaderStatusApproval(true)
    await axiosRequest({
      url: "bu_head_app/commercialheadapprovebuhead/",
      method: "POST",
      data: data,
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setloaderStatusApproval(false);
        handleSnackBar("Status updated successfully", "success");
        gettabledata();
        
      } else {
        setloaderStatusApproval(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  }
  const handleStatusApproval =async (row) =>{
    setchangedStatusId(row.id)
    const postData = {
      "teamcode": row?.teamcode,
      "year": row?.year,
      "quarter": row?.quarter,
      "id": row?.id,
      "status": "submitted"
  }
  console.log(postData,"POST")
  statusApproval(postData)
  }
  const handleStatusRBMApproval = async(row) =>{
  setchangedStatusRBMId(row.id)
    const postData = {
      "teamcode": row?.teamcode,
      "year": row?.year,
      "quarter": row?.quarter,
      "id": row?.id,
      "status": "submitted"
  }
  setloaderStatusRBMApproval(true)
  await axiosRequest({
    url: "bu_head_app/commercialheadapproveabm/",
    method: "POST",
    data: postData,
    headers: api_headers,
  }).then((data) => {
    if (data.status === 200) {
      setloaderStatusRBMApproval(false);
      handleSnackBar("Status updated successfully", "success");
      gettabledata();
      
    } else {
      setloaderStatusRBMApproval(false);
      handleSnackBar("Something went wrong", "error");
    }
  });
  }
  const handleCloseReset = () => {
    setOpenReset(false);
  };
  const TriggerReset = () => {
    setOpenReset(true);
  };
  const handleTabChange = (event, newValue) => {
    setLoader(true);
    setTabValue(newValue);
    setPage(0);
    if (newValue === 0) {
      setTabValueName("Approval");
      setHeadCells(appheadcells);
      setRows(approws);
      setOrgRows(approws);
      setLoader(false);
    } else {
      setTabValueName("RBM Approval");
      setHeadCells(rbmappheadcells);
      setRows(rbmapprows);
      setOrgRows(rbmapprows);
      setLoader(false);
    }
  };
  const optionsTemp = [
    { label: "foo", value: "foo" },
    { label: "bar", value: "bar" },
    { label: "jar", value: "jar" },
    { label: "nar", value: "nar" },
    { label: "mar", value: "mar" },
    { label: "far", value: "far" },
  ];
  const [selectedOptionsTeams, setSelectedOptionsTeams] = useState([]);
  const [selectedOptionsRbm, setSelectedOptionsRbm] = useState([]);
  const [selectedOptionsAbm, setSelectedOptionsAbm] = useState([]);
  const [selectedOptionsRephq, setSelectedOptionsRephq] = useState([]);
  const [selectedOptionsQuarter, setSelectedOptionsQuarter] = useState([]);
  const [selectedOptionsYear, setSelectedOptionsYear] = useState([]);
  const getOptionLabelRbm = (option) =>
    `${option.rbmcode}` + " - " + `${option.rbmname}`;
  const getOptionLabelAbm = (option) =>
    `${option.abmcode}` + " - " + `${option.abmname}`;
  const getOptionLabelRephq = (option) =>
    `${option.repcode}` + " - " + `${option.repname}`;
  const getOptionLabelQuarter = (option) => `${option.quarter}`;
  const getOptionLabelYear = (option) => `${option.year}`;
  const getOptionDisabled = (option) => option.rbmcode === "foo";
  const handleToggleOptionRbm = (selectedOptionsRbm) =>
    setSelectedOptionsRbm(selectedOptionsRbm);
  const handleToggleOptionAbm = (selectedOptionsAbm) =>
    setSelectedOptionsAbm(selectedOptionsAbm);
  const handleToggleOptionRephq = (selectedOptionsRephq) =>
    setSelectedOptionsRephq(selectedOptionsRephq);
  const handleToggleOptionQuarter = (selectedOptionsQuarter) =>
    setSelectedOptionsQuarter(selectedOptionsQuarter);
  const handleToggleOptionYear = (selectedOptionsYear) =>
    setSelectedOptionsYear(selectedOptionsYear);
  const handleClearOptionsRbm = () => setSelectedOptionsRbm([]);
  const handleClearOptionsAbm = () => setSelectedOptionsAbm([]);
  const handleClearOptionsRephq = () => setSelectedOptionsRephq([]);
  const handleClearOptionsQuarter = () => setSelectedOptionsQuarter([]);
  const handleClearOptionsYear = () => setSelectedOptionsYear([]);
  const handleSelectAllRbm = (isSelected) => {
    if (isSelected) {
      setSelectedOptionsRbm(rbmcodesListReset);
    } else {
      handleClearOptionsRbm();
    }
  };
  const handleSelectAllAbm = (isSelected) => {
    if (isSelected) {
      setSelectedOptionsAbm(abmcodesListReset);
    } else {
      handleClearOptionsAbm();
    }
  };
  const handleSelectAllRephq = (isSelected) => {
    if (isSelected) {
      setSelectedOptionsRephq(repcodesListReset);
    } else {
      handleClearOptionsRephq();
    }
  };
  const handleSelectAllQuarter = (isSelected) => {
    if (isSelected) {
      setSelectedOptionsQuarter(quartersListReset);
    } else {
      handleClearOptionsQuarter();
    }
  };
  const handleSelectAllYear = (isSelected) => {
    if (isSelected) {
      setSelectedOptionsYear(yearsListReset);
    } else {
      handleClearOptionsYear();
    }
  };
  React.useEffect(() => {
    // console.log(selectedOptionsRbm,"rbm options")
    let rbm_reset = [];
    if (selectedOptionsRbm.length > 0) {
      for (let item of rows) {
        for (let selected of selectedOptionsRbm) {
          if (item["rbmcode"] === selected["rbmcode"]) {
            if (
              !rbm_reset.find((object) => object["abmcode"] === item["abmcode"])
            ) {
              rbm_reset.push(item);
            }
          }
        }
      }
      setAbmcodesListReset(rbm_reset);
    }
  }, [selectedOptionsRbm]);
  React.useEffect(() => {
    // console.log(selectedOptionsRbm,"rbm options")
    let rbm_reset = [];
    if (selectedOptionsAbm.length > 0) {
      for (let item of rows) {
        for (let selected of selectedOptionsAbm) {
          if (item["abmcode"] === selected["abmcode"]) {
            if (
              !rbm_reset.find((object) => object["repcode"] === item["repcode"])
            ) {
              rbm_reset.push(item);
            }
          }
        }
      }
      setRepcodesListReset(rbm_reset);
    }
  }, [selectedOptionsAbm]);
  React.useEffect(() => {
    // console.log(selectedOptionsRbm,"rbm options")
    let rbm_reset = [];
    if (selectedOptionsRephq.length > 0) {
      for (let item of rows) {
        for (let selected of selectedOptionsRephq) {
          if (item["repcode"] === selected["repcode"]) {
            if (
              !rbm_reset.find((object) => object["quarter"] === item["quarter"])
            ) {
              rbm_reset.push(item);
            }
          }
        }
      }
      setQuartersListReset(rbm_reset);
      setYearsListReset(rbm_reset);
    }
  }, [selectedOptionsRephq]);
  const getResetOptionsData = (page, data) => {
    let teams_reset = [];
    for (let row of data) {
      if (!teams_reset.includes(row["teamcode"])) {
        teams_reset.push(row["teamcode"]);
      }

      // if(!rbm_reset.find(object => object['rbmcode'] === row['rbmcode'])){
      //   rbm_reset.push(row)
      // }
      // if(!quarter_reset.includes(row['quarter'])){
      //   quarter_reset.push(row['quarter'])
      // }
      // if(!year_reset.includes(row['year'])){
      //   year_reset.push(row['year'])
      // }
      // if(page>=1){
      //   if(!abm_reset.find(object => object['abmcode'] === row['abmcode'])){
      //     abm_reset.push(row)
      //   }
      // }
      // if(page>=2){
      //   if(!rep_reset.find(object => object['repcode'] === row['repcode'])){
      //     rep_reset.push(row)
      //   }
      // }
    }
    setTeamsListReset(teams_reset);
    // setRbmcodesListReset(rbm_reset)
    // setAbmcodesListReset(abm_reset)
    // setRepcodesListReset(rep_reset)
    // setQuartersListReset(quarter_reset)
    // setYearsListReset(year_reset)
    // console.log(teams_reset,rbm_reset,quarter_reset,year_reset,abm_reset,rep_reset)
  };
  const handleTabChangeTemplate = (event, newValue) => {
    setLoader(true);
    setTabValueTemplate(newValue);
    setNewTeamsData("buhead");
    setPage(0);
    if (newValue === 0) {
      setTabValueTemplateName("BUH TEMPLATE");
      setNewTeamsData("buhead");
      setHeadCells(rbmtemplateheadcells);
      setRows(rbmtemplate);
      setOrgRows(rbmtemplate);
      setLoader(false);
      // getResetOptionsData(0,rbmtemplate)
      //teamcode rbmcode quarter year
    }
    if (newValue === 1) {
      setTabValueTemplateName("RBM-ABM Level");
      setNewTeamsData("abm");
      setHeadCells(abmtemplateheadcells);
      setRows(abmtemplate);
      setOrgRows(abmtemplate);
      setLoader(false);
      // getResetOptionsData(1,abmtemplate)
      //teamcode rbmcode abmcode quarter year
    }
    if (newValue === 2) {
      setTabValueTemplateName("RBM-Rephq Level");
      setNewTeamsData("rephq");
      setHeadCells(rephqtemplateheadcells);
      setRows(rephqtemplate);
      setOrgRows(rephqtemplate);
      setLoader(false);
      // getResetOptionsData(2,rephqtemplate)
      //teamcode rbmcode abmcode repcode quarter year
    }
  };
  const onchangeReset = (event) => {
    // submitDelete(selectedDeleteId)
    // console.log(values, "on");
    // setAbmcode(values)
    const {
      target: { value },
    } = event;
    let rbm_reset = [];
    console.log(value, "value");
    setSelectedOptionsTeams(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    for (let item of rows) {
      if (value === item["teamcode"]) {
        if (
          !rbm_reset.find((object) => object["rbmcode"] === item["rbmcode"])
        ) {
          rbm_reset.push(item);
        }
      }
    }

    setRbmcodesListReset(rbm_reset);

    // gettabledata()
  };
  function get_values(data, column) {
    let temp_list = [];
    for (let item of data) {
      temp_list.push(item[column]);
    }
    return temp_list;
  }
  const handleResetSubmit = async () => {
    setLoaderReset(true);
    await axiosRequest({
      url: "admin_app/budgetreset",
      method: "POST",
      data: {
        source_name: newTeamsData,
        teamcode: selectedOptionsTeams[0],
        rbmcode: get_values(selectedOptionsRbm, "rbmcode"),
        abmcode: get_values(selectedOptionsAbm, "abmcode"),
        rephqcode: get_values(selectedOptionsRephq, "repcode"),
        quarter: get_values(selectedOptionsQuarter, "quarter"),
        year: get_values(selectedOptionsYear, "year"),
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoaderReset(false);
        handleSnackBar("Data Saved Successfully", "success");
        setSelectedOptionsRbm([]);
        setSelectedOptionsAbm([]);
        setSelectedOptionsRephq([]);
        setSelectedOptionsQuarter([]);
        setSelectedOptionsYear([]);
        setSelectedOptionsTeams([]);
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoaderReset(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };

  let users_headers = [
    { label: "id", key: "id" },
    { label: "email", key: "email" },
    { label: "role", key: "role" },
    { label: "employee_name", key: "employee_name" },
    { label: "team_code", key: "team_code" },
    { label: "reports_to", key: "reports_to" },
    { label: "rbm_code", key: "rbm_code" },
    { label: "abm_code", key: "abm_code" },
    { label: "hq_code", key: "hq_code" },
    { label: "dt_code", key: "dt_code" },
    { label: "quarter_name", key: "quarter_name" },
    { label: "rbm_screen", key: "rbm_screen" },
  ];
  const handleClickOpenDel = async () => {
    await submitDelete(selectedDeleteId);
    handleCloseDel();
    await gettabledata();
  };
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const handleClickSaveUser = async () => {
    // submitDelete(selectedDeleteId)
    // submitSave()
    let check = 0;
    for (const [key, value] of Object.entries(newUser)) {
      // console.log(key, value);
      if (
        value === "" &&
        key != "dt_code" &&
        key != "abm_code" &&
        key != "hq_code" &&
        key != "rbm_code" &&
        key != "rbm_screen"
      ) {
        check = check + 1;
      }
    }
    if (check <= 0) {
      // await submitEdit();
      // gettabledata();
      if (
        newUser["email"] !== "already exists" &&
        newUser["employee_name"] !== "already exists"
      ) {
        if (newUser["email"].includes("gsk.com")) {
          // console.log(check)
          await submitCreatedUser();
          await gettabledata();
          setNewUserRole("");
          handleCloseUser();
        } else {
          handleSnackBar("Email should contain gsk.com", "error");
        }
      } else {
        if (newUser["email"] == "already exists") {
          handleSnackBar("Email already exists", "error");
        } else {
          handleSnackBar("Employee name already exists", "error");
        }
      }
    } else {
      handleSnackBar("Please Fill All Values", "error");
    }

    // gettabledata()
  };
  const handleCloseDel = () => {
    setOpenDel(false);
  };
  const handleCloseTriggerUp = () => {
    setOpenTriggerUp(false);
  };
  const handleCloseUser = () => {
    setOpenUser(false);
  };
  const handleClose = () => {
    setOpensb(false);
  };
  const handleCloseTeams = () => {
    setOpenTeams(false);
  };
  const handleOpenTeams = () => {
    setOpenTeams(true);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const addNewUser = () => {
    let userdata = {
      employee_name: "",
      email: "",
      team_code: "",
      reports_to: "",
      role: "",
      abm_code: "",
      hq_code: "",
      dt_code: "",
      quarter_name: "",
      rbm_code: "",
      rbm_screen: "",
    };
    setNewUser(userdata);
    setOpenUser(true);
  };
  // const changeHandler = (event) => {
  //   setSelectedFile(event.target.files[0]);
  //   console.log(event.target.files[0],"-------")
  //   var formData = new FormData();
  //   formData.append("file", event.target.files[0]);
  //   formData.append("source_name", table);
  //   // const DataSize = parseInt(event.target.files[0].size)/1024
  //   // console.log(DataSize,"########")
  //   setFile(formData)
  //   // setIsFilePicked(true);

  //   // UploadFile()
  // };

  var formData = new FormData();
  const changeHandler = (event) => {
    // console.log("FILE CHANGED");
    let img = event.target.files[0];
    // var filename="ptl.csv";

    formData.append("file", img);
    formData.append("source_name", table);
    // console.log(event.target.files[0].name, "FORM DATAA");
    setFile(formData);
    setIsFilePicked(true);

    setselectedFileName(event.target.files[0].name);
  };
  var formData1 = new FormData();
  const changeHandlerTeams = (event) => {
    // console.log("FILE CHANGED");
    let img = event.target.files[0];
    // var filename="ptl.csv";

    formData1.append("file", img);
    formData1.append("source_name", newTeamsData);
    // console.log(event.target.files[0].name, "FORM DATAA");
    setFileTeams(formData1);
    setIsFilePickedTeams(true);

    setselectedFileNameTeams(event.target.files[0].name);
  };
  const changeHandlerUserBulk = (event) => {
    // console.log("FILE CHANGED");
    let img = event.target.files[0];
    // var filename="ptl.csv";

    formData.append("file", img);
    // console.log(event.target.files[0].name, "FORM DATAA");
    setFile(formData);
    setIsFilePicked(true);

    setselectedFileName(event.target.files[0].name);
  };

  useEffect(() => {
    gettabledata();
  }, [table]);

  const UploadFile = () => {
    if (file != "") {
      setloaderUpload(true);
      axiosRequest({
        url: "admin_app/upload",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("Token"),
        },
        data: file,
      }).then((data) => {
        if (data.status === 200) {
          setIsFilePicked(false);
          handleSnackBar("uploaded successfully", "success");
          setloaderUpload(false);
          formData = new FormData();
          // formData.append("source_name", "");
          setFile("");
        } else {
          handleSnackBar("upload failed", "error");
          setloaderUpload(false);
          formData = new FormData();
          setFile("");
        }
        // setIsFileUploaded(response.data['any_duplicates'])

        // if (response.data['Status'] === "Success") {
        //   let text = "Data insertion is Success\n"+(response.data['message'])+"\nTotal Records: "+(response.data['total_records_count'])+"\nInserted Records: "+(response.data['inserted_records_count'])+"\nDuplicates: "+(response.data['duplicates_count'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("success")
        // } else {
        //   console.log("else alert")
        //   let text = "Data insertion is failed  \n"+(response.data['message'])+"\nthis are the columns: "+(response.data['columns'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("error")

        // }
      });
    } else {
      handleSnackBar("Please Select file before uploading", "warning");
    }
  };
  const UploadFileTeams = () => {
    if (fileTeams != "") {
      setloaderUploadTeams(true);
      axiosRequest({
        // url: "admin_app/upload-dissiminateddata",
        url:"rbm_app/upsertdatabuhead/",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("Token"),
        },
        data: fileTeams,
      }).then((data) => {
        if (data.status === 200) {
          setIsFilePickedTeams(false);
          handleSnackBar("uploaded successfully", "success");
          setloaderUploadTeams(false);
          formData = new FormData();
          // formData.append("source_name", "");
          setFileTeams("");
        } else {
          handleSnackBar("upload failed", "error");
          setloaderUploadTeams(false);
          formData = new FormData();
          setFileTeams("");
        }
        // setIsFileUploaded(response.data['any_duplicates'])

        // if (response.data['Status'] === "Success") {
        //   let text = "Data insertion is Success\n"+(response.data['message'])+"\nTotal Records: "+(response.data['total_records_count'])+"\nInserted Records: "+(response.data['inserted_records_count'])+"\nDuplicates: "+(response.data['duplicates_count'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("success")
        // } else {
        //   console.log("else alert")
        //   let text = "Data insertion is failed  \n"+(response.data['message'])+"\nthis are the columns: "+(response.data['columns'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("error")

        // }
      });
    } else {
      handleSnackBar("Please Select file before uploading", "warning");
    }
  };
  const MakeTrigger = () => {
    // setloaderDownloadTrig(true);
    setOpenTriggerUp(true);
    // axiosRequest({
    //   url: "bu_head_app/getmail/",
    //   method: "GET",
    // }).then((data) => {
    //   if (data.status === 200) {
    //     handleSnackBar("Triggered successfully", "success");
    //     setloaderDownloadTrig(false);
    //   } else {
    //     handleSnackBar("Trigger failed", "error");
    //     setloaderDownloadTrig(false);
    //   }

    // });
  };
  const MakeTriggerWithTeams = () => {
    setloaderDownloadTrig(true);
    setOpenTriggerUp(true);
    console.log(selectedTrigger, "selected trigger");
    axiosRequest({
      url: "bu_head_app/getmail/",
      method: "POST",
      data: { teams: selectedTrigger },
    }).then((data) => {
      if (data.status === 200) {
        handleSnackBar("Triggered successfully", "success");
        setloaderDownloadTrig(false);
      } else {
        handleSnackBar("Trigger failed", "error");
        setloaderDownloadTrig(false);
      }
      setSelectedTrigger([]);
    });
  };
  const UploadFileUserBulk = () => {
    if (file != "") {
      setloaderUpload(true);
      axiosRequest({
        url: "users/bulkcreate/",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("Token"),
        },
        data: file,
      }).then((data) => {
        if (data.status === 200) {
          // console.log(data?.data);
          setDuplicates(false);
          setIsFilePicked(false);

          handleSnackBar("Data uploaded successfully", "success");

          setloaderUpload(false);
          formData = new FormData();
          // formData.append("source_name", "");
          setFile("");
        } else {
          handleSnackBar("upload failed", "error");
          setloaderUpload(false);
          formData = new FormData();
          setFile("");
        }
        // setIsFileUploaded(response.data['any_duplicates'])

        // if (response.data['Status'] === "Success") {
        //   let text = "Data insertion is Success\n"+(response.data['message'])+"\nTotal Records: "+(response.data['total_records_count'])+"\nInserted Records: "+(response.data['inserted_records_count'])+"\nDuplicates: "+(response.data['duplicates_count'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("success")
        // } else {
        //   console.log("else alert")
        //   let text = "Data insertion is failed  \n"+(response.data['message'])+"\nthis are the columns: "+(response.data['columns'])
        //   setopensnackbar(true)
        //   setcontent(text)
        //   setseverity("error")

        // }
      });
    } else {
      handleSnackBar("Please Select file before uploading", "warning");
    }
  };

  // useEffect(() => {
  //   if (isFilePicked == true) {
  //     UploadFile();
  //   }
  // });

  const TeamsEdit = async (teamsdata) => {
    await axiosRequest({
      url: "admin_app/statusupdateteams",
      method: "POST",
      data: teamsdata,
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        // setLoader(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        // setLoader(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  let table_data_url = "admin_app/tabledata/" + table;
  const gettabledata = async () => {
    setLoader(true);
    await axiosRequest({
      url: `${table_data_url}?quarter=${localStorage.getItem("quarter")}&year=${localStorage.getItem("year")}`,
      method: "GET",
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        if (table === "approval") {
          setAppHeadCells([
            ...data?.data?.app_headers,
            {
              id: "update_status",
              numeric: false,
              disablePadding: false,
              label: "Update Status",
              width: "80px",
            },
          ]);
          setRbmAppHeadCells([
            ...data?.data?.rbmapp_headers,
            {
              id: "update_status",
              numeric: false,
              disablePadding: false,
              label: "Update Status",
              width: "80px",
            },
          ]);
          // setAppHeadCells([...appheadcells,
          //   ])
          //   setRbmAppHeadCells([...rbmappheadcells,
          //     {id: "update_status", numeric: false, disablePadding: false, label: "Update Status", width: "80px"}])
          setAppRows(data?.data?.app_data);
          setRbmAppRows(data?.data?.rbmapp_data);

          if (TabValue === 0) {
            setHeadCells([
              ...data?.data?.app_headers,
              {
                id: "update_status",
                numeric: false,
                disablePadding: false,
                label: "Update Status",
                width: "80px",
              },
            ]);
            setRows(data?.data?.app_data);
            setOrgRows(data?.data?.app_data);
            setLoader(false);
          } else {
            setHeadCells([
              ...data?.data?.rbmapp_headers,
              {
                id: "update_status",
                numeric: false,
                disablePadding: false,
                label: "Update Status",
                width: "80px",
              },
            ]);
            setRows(data?.data?.rbmapp_data);
            setOrgRows(data?.data?.rbmapp_data);
            setLoader(false);
          }
        } else {
          if (table === "templates") {
            setRbmTemplate(data?.data?.rbm_template);
            setAbmTemplate(data?.data?.abm_template);
            setRephqTemplate(data?.data?.rephq_template);
            setRbmTemplateHeadCells(data?.data?.rbm_headers);
            setAbmTemplateHeadCells(data?.data?.abm_headers);
            setRephqTemplateHeadCells(data?.data?.rephq_headers);
            getResetOptionsData(2, data?.data?.rephq_template);
            if (TabValueTemplate === 0) {
              setHeadCells(data?.data?.rbm_headers);
              setRows(data?.data?.rbm_template);
              setOrgRows(data?.data?.rbm_template);
              setLoader(false);
            }
            if (TabValueTemplate === 1) {
              setHeadCells(data?.data?.abm_headers);
              setRows(data?.data?.abm_template);
              setOrgRows(data?.data?.abm_template);
              setLoader(false);
            }
            if (TabValueTemplate === 2) {
              setHeadCells(data?.data?.rephq_headers);
              setRows(data?.data?.rephq_template);
              setOrgRows(data?.data?.rephq_template);
              setLoader(false);
            }
          } else {
            setHeadCells(data?.data?.headers);
            setRows(data?.data?.data);
            setOrgRows(data?.data?.data);
            setLoader(false);
          }
        }
      } else {
        handleSnackBar("Unable to load the data", "error");
        setLoader(false);
      }
    });
  };
  let table_backup_data_url = "admin_app/backuptabledata/" + table;
  const getbackuptabledata = async () => {
    setLoaderBackup(true);
    await axiosRequest({
      url: table_backup_data_url,
      method: "GET",
      headers: api_headers,
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      let temp_file_name = table + "_backup" + ".csv";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", temp_file_name);
      document.body.appendChild(link);
      link.click();
      handleSnackBar("downloaded successfully", "success");
      setLoaderBackup(false);
    });
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  let temp_url = "users/downloadduplicates/";
  const downloadDuplicates = async () => {
    setLoaderDownloadDup(true);
    await axiosRequest({
      url: temp_url,
      method: "GET",
      headers: api_headers,
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      let temp_file_name = "duplicates" + ".csv";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", temp_file_name);
      document.body.appendChild(link);
      link.click();
      handleSnackBar("downloaded successfully", "success");
      setLoaderDownloadDup(false);
    });
    setDuplicates(false);
  };

  const DataTriggers = async (temp_url, temp1) => {
    // setLoaderDownloadDup(true);
    await axiosRequestProd({
      url: temp_url,
      method: "GET",
    }).then((data) => {
      if (data.status === 200) {
        TeamsEdit(temp1);
        setLoaderTeams(false);
        setLoaderTeams1(false);
        setLoaderTeams2(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoaderTeams(false);
        setLoaderTeams1(false);
        setLoaderTeams2(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  const submitEdit = async () => {
    await axiosRequest({
      url: "admin_app/edit",
      method: "POST",
      data: {
        table: table,
        data: selectedEditRow,
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  const submitCreatedUser = async () => {
    setLoaderSaveUser(true);
    await axiosRequest({
      url: "users/create/",
      method: "POST",
      data: {
        newUser,
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoaderSaveUser(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoaderSaveUser(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };
  const submitDelete = async (id) => {
    await axiosRequest({
      url: "admin_app/delete",
      method: "POST",
      data: {
        table: table,
        id: id,
      },
      headers: api_headers,
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        handleSnackBar("Data Saved Successfully", "success");
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        handleSnackBar("Something went wrong", "error");
      }
    });
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const onchangeTeamsUploadData = (event) => {
    setNewTeamsData(event.target.value);
  };
  const onchangeUser = (event, key) => {
    // console.log(event.target.value,key,"dakjds");
    let email_check = 0;
    let emply_check = 0;
    if (key === "email") {
      for (let item of rows) {
        if (item["email"] == event.target.value) {
          email_check = email_check + 1;
          newUser[key] = "already exists";
          handleSnackBar(
            "This email already exist We cant create user",
            "error"
          );
        }
      }
    }
    // if (key === "employee_name") {
    //   for (let item of rows) {
    //     if (item["employee_name"] == event.target.value) {
    //       emply_check = emply_check + 1;
    //       newUser[key] = "already exists";
    //       handleSnackBar(
    //         "This Employee already exist We cant create user",
    //         "error"
    //       );
    //     }
    //   }
    // }
    if (key === "role") {
      setNewUserRole(event.target.value);
    }
    if (email_check == 0 && emply_check == 0) {
      newUser[key] = event.target.value;
    }
  };
  const handleEdit = (event, row) => {
    setEditingIndex(row.id);
    setEffStartDate(row["effective_start_date"]);
    setEffendDate(row["effective_end_date"]);
    setSelectedEditRow(row);
    // console.log("edit", event, row.id);
  };
  const handleEditClose = (event, id) => {
    setEditingIndex(0);
    // console.log("edit close", event, id);
  };
  const handleEditSave = async (event, id) => {
    // console.log(selectedEditRow);
    setEditReady(true);
    let check = 0;
    if (table !== "user") {
      selectedEditRow["effective_start_date"] =
        moment(effStartDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
      selectedEditRow["effective_end_date"] =
        moment(effEndDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    for (const [key, value] of Object.entries(selectedEditRow)) {
      // console.log(key, value);
      if (
        value === "" &&
        key != "dt_code" &&
        key != "abm_code" &&
        key != "hq_code" &&
        key != "rbm_code" &&
        key != "rbm_screen"
      ) {
        check = check + 1;
      }
    }
    if (check <= 0) {
      await submitEdit();
      await gettabledata();
      setEditingIndex(0);
      setEditReady(false);
    } else {
      setEditReady(false);
      handleSnackBar("Please Fill All Values", "error");
    }
    // console.log("edit save", event, id,selectedEditRow);
  };
  const handleDelete = (event, id) => {
    // console.log("delete", event, id);
    setOpenDel(true);
    setSelectedDeleteId(id);
  };

  const inputChangeHandler = (event, value, id, key) => {
    // console.log(value);
    // console.log(selectedEditRow);
    if (key == "effective_start_date" || key == "effective_end_date") {
      // console.log("in");
      selectedEditRow[key] = value;
    } else {
      selectedEditRow[key] = event.target.value;
    }

    // console.log("inputChangeHandler", event.target.value, value, id, key);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  function checkRows(row, searched) {
    let check_rows = [];
    Object.keys(row).forEach((key) =>
      check_rows.push(String(row[key])?.toLowerCase().includes(searched))
    );
    if (check_rows.includes(true)) {
      return true;
    } else {
      return false;
    }
  }
  const requestSearch = (searched) => {
    // console.log(searched, "aksdj");
    if (searched === "") {
      // console.log("empyt");
      setRows(orgRows);
    } else {
      searched = searched.toLowerCase();
      setRows(orgRows.filter((item) => checkRows(item, searched)));
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const handleGenerate = async (e, key, row) => {
    if (key === "adjusted_data") {
      setLoaderTeams1(true);
    }
    if (key === "stitched_data") {
      setLoaderTeams(true);
    }
    if (key === "disseminated_data") {
      setLoaderTeams2(true);
    }
    setSelectedEditRow(row);

    console.log(key, row.id, "kjahd");
    let temp1 = {
      id: row.id,
      key: key,
    };
    if (key === "adjusted_data") {
      await DataTriggers("automation_app/adjustedtrigger/", temp1);
    }
    if (key === "stitched_data") {
      await DataTriggers("automation_app/stitchedtrigger/", temp1);
    }
    if (key === "disseminated_data") {
      await DataTriggers("automation_app/disseminationtrigger/", temp1);
    }
    await gettabledata();
  };
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%" }} className="admin-tables">
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <CircularProgress color="inherit" display={loader.toString()} />
        </div>
      ) : (
        <Paper sx={{ width: "100%", mb: 2 }}>
          {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
          <div
            style={{
              textAlign: "right",
              padding: "10px",
              backgroundColor: "tranparent",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {/* <label
        for="countries"
        class="block  mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
      >
        Upload file 
      </label> */}

            {/* <button
          style={{ fontSize: 12 }}
          onClick={handleSubmission}
          type="button"
          class="focus:outline-none text-white bg-green-600 hover:bg-green-800 focus:ring-green-300 font-small rounded-lg text-sm px-5 py-1 mt-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
        >
          Upload
        </button> */}

            <ThemeProvider theme={theme}>
              {/* <Button sx={{color:"black"}} color="secondary" variant="contained" component="label" startIcon={<FileUploadIcon />}>
            Upload
            <input hidden accept=".csv"  type="file" onChange={changeHandler}/>
        </Button> */}
              {/* 
              <p style={{ fontWeight: "550" ,display:table==='templates'?'none':'block'}}>
                {table === "approval" ? (
                  <span>{TabValue === 0 ? "APPROVAL" : "RBM APPROVAL"}</span>
                ) : (
                  <span>{table.replaceAll("_", " ").toUpperCase()}</span>
                )}
              </p> */}
              {/* <span style={{ textAlign:"left",color: "#FD7D21" }}>BUDGET DISSEMINATION TOOL - <span style={{ color: "black" }}>{table.replace("_"," ").toUpperCase()}</span></span> */}
              {table === "user" ? (
                <div className="search">
                  <Button
                    sx={{ ml: 1, width: "180px", height: "35px" }}
                    style={{
                      backgroundColor: "#FF6A0A",
                      color: "white",
                      textTransform: "none",
                    }}
                    variant="contained"
                    component="span"
                    startIcon={
                      <FileDownloadIcon
                        style={{ display: loaderDownload ? "none" : "" }}
                        fontSize="small"
                      />
                    }
                    // onClick={downloadDuplicates}
                  >
                    {" "}
                    {loaderDownload == true ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: loaderDownload ? "space-between" : "",
                        }}
                      >
                        <CircularProgress
                          size="1rem"
                          color="inherit"
                          display={loaderDownload == true ? "true" : "false"}
                        />
                      </div>
                    ) : (
                      <CSVLink
                        data={rows}
                        headers={users_headers}
                        filename={table + ".csv"}
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Download Data
                      </CSVLink>
                    )}
                  </Button>
                  <Button
                    sx={{ ml: 1, width: "240px", height: "35px" }}
                    style={{
                      backgroundColor: "#FF6A0A",
                      color: "white",
                      textTransform: "none",
                    }}
                    variant="contained"
                    component="span"
                    startIcon={<AddCircleOutlineIcon fontSize="small" />}
                    onClick={addNewUser}
                  >
                    {" "}
                    <span>ADD NEW USER</span>
                  </Button>
                  <Input
                    disableUnderline={true}
                    variant="contained"
                    className="search-in"
                    placeholder="search..."
                    type="search"
                    endAdornment={
                      <InputAdornment position="end">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    }
                    onKeyUp={(e) => requestSearch(e.target.value)}
                    onKeyDown={(e) => requestSearch(e.target.value)}
                  />
                </div>
              ) : (
                <div>
                  {table === "approval" ? (
                    <div style={{ display: "flex" }}>
                      <Input
                        style={{ marginTop: "4px", marginRight: "10px" }}
                        disableUnderline={true}
                        variant="contained"
                        className="search-in"
                        placeholder="search..."
                        type="search"
                        endAdornment={
                          <InputAdornment position="end">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        }
                        onKeyUp={(e) => requestSearch(e.target.value)}
                        onKeyDown={(e) => requestSearch(e.target.value)}
                      />
                      <Tabs
                        onChange={handleTabChange}
                        value={TabValue}
                        aria-label="Tabs where each tab needs to be selected manually"
                      >
                        <Tab label="Approval" />
                        <Tab label="RBM Approval" />
                      </Tabs>
                      <Button
                        variant="contained"
                        style={{
                          height: "35px",
                          marginLeft: "10px",
                          backgroundColor: "#e5e5e5",
                          textTransform: "none",
                          color: "black",
                          marginTop: "5px",
                        }}
                      >
                        <CSVLink
                          data={rows}
                          filename={TabValueName + ".csv"}
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          Download Data
                        </CSVLink>
                      </Button>
                    </div>
                  ) : (
                    <div>
                      {table === "templates" ? (
                        <div style={{ display: "flex" }}>
                          <Tabs
                            onChange={handleTabChangeTemplate}
                            value={TabValueTemplate}
                            aria-label="Tabs where each tab needs to be selected manually"
                          >
                            <Tab label="BUH Template" />
                            <Tab label="RBM-ABM Level" />
                            <Tab label="RBM-Rephq Level" />
                          </Tabs>
                          <p
                            style={{
                              width: "60px",
                              fontWeight: "550",
                              display: table === "templates" ? "block" : "none",
                            }}
                          ></p>
                          <Input
                            style={{ marginTop: "4px", marginRight: "10px" }}
                            disableUnderline={true}
                            variant="contained"
                            className="search-in"
                            placeholder="search..."
                            type="search"
                            endAdornment={
                              <InputAdornment position="end">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            }
                            onKeyUp={(e) => requestSearch(e.target.value)}
                            onKeyDown={(e) => requestSearch(e.target.value)}
                          />
                          {loaderDownload == true ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: loaderDownload
                                  ? "space-between"
                                  : "",
                              }}
                            >
                              <CircularProgress
                                size="1rem"
                                color="inherit"
                                display={
                                  loaderDownload == true ? "true" : "false"
                                }
                              />
                            </div>
                          ) : (
                            <Button
                              variant="contained"
                              style={{
                                height: "35px",
                                marginLeft: "10px",
                                backgroundColor: "#e5e5e5",
                                textTransform: "none",
                                color: "black",
                                marginTop: "5px",
                              }}
                            >
                              <CSVLink
                                data={rows}
                                headers={Array.isArray(rows?.[0]) ? (headcells || []).map((h) => h.id) : undefined}
                                filename={TabValueTemplateName + ".csv"}
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                              >
                                Download Data
                              </CSVLink>
                            </Button>
                          )}
                          <div style={newTeamsData === "abm" ?{display:"none"}:{display:'flex'}}>
                          <Button
                            style={{
                              backgroundColor: "#e5e5e5",
                              color: "black",
                              height: "35px",
                              textTransform: "none",
                              fontSize: "13px",
                              marginLeft: "10px",
                              marginTop: "5px",
                            }}
                            variant="contained"
                            component="label"
                          >
                            <AttachmentIcon
                              size="small"
                              style={{ marginRight: "5px" }}
                            />
                         
                            {isFilePickedTeams
                              ? selectedFileNameTeams
                              : "Select File"}
                            <input
                              onChange={changeHandlerTeams}
                              onClick={(event) => {
                                event.target.value = null;
                              }}
                              hidden
                              accept="/*"
                              type="file"
                            />
                          </Button>
                          <LoadingButton
                            onClick={UploadFileTeams}
                            loading={loaderUploadTeams}
                            variant="contained"
                            style={{
                              height: "35px",
                              marginLeft: "10px",
                              backgroundColor: "#e5e5e5",
                              textTransform: "none",
                              color: "black",
                              marginTop: "5px",
                            }}
                          >
                            <FileUploadIcon
                              style={{
                                display: loaderUploadTeams ? "none" : "",
                              }}
                              fontSize="small"
                            />
                            {loaderUploadTeams ? "" : "Upload"}
                          </LoadingButton>
                          </div>
                          {newTeamsData === "rephq" ? (
                            <Button
                              variant="contained"
                              style={{
                                height: "35px",
                                marginLeft: "10px",
                                backgroundColor: "red",
                                textTransform: "none",
                                color: "black",
                                marginTop: "5px",
                              }}
                              onClick={TriggerReset}
                            >
                              RESET
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div style={{ display: "flex" }}>
                          <Input
                            style={{ marginRight: "10px" }}
                            disableUnderline={true}
                            variant="contained"
                            className="search-in"
                            placeholder="search..."
                            type="search"
                            endAdornment={
                              <InputAdornment position="end">
                                <SearchIcon fontSize="small" />
                              </InputAdornment>
                            }
                            onKeyUp={(e) => requestSearch(e.target.value)}
                            onKeyDown={(e) => requestSearch(e.target.value)}
                          />
                          <Button
                            style={{
                              backgroundColor: "#e5e5e5",
                              color: "black",
                              height: "38px",
                              textTransform: "none",
                              fontSize: "13px",
                            }}
                            variant="contained"
                            component="label"
                          >
                            <AttachmentIcon
                              size="small"
                              style={{ marginRight: "5px" }}
                            />
                            {isFilePicked ? selectedFileName : "Select File"}
                            <input
                              onChange={changeHandler}
                              onClick={(event) => {
                                event.target.value = null;
                              }}
                              hidden
                              accept="/*"
                              type="file"
                            />
                          </Button>
                          <LoadingButton
                            onClick={UploadFile}
                            loading={loaderUpload}
                            variant="contained"
                            style={{
                              height: "38px",
                              marginLeft: "10px",
                              backgroundColor: "#e5e5e5",
                              textTransform: "none",
                              color: "black",
                            }}
                          >
                            <FileUploadIcon
                              style={{ display: loaderUpload ? "none" : "" }}
                              fontSize="small"
                            />
                            {loaderUpload ? "" : "Upload"}
                          </LoadingButton>
                          {table === "emails" ? (
                            <Button
                              sx={{ ml: 1, width: "180px", height: "38px" }}
                              onClick={MakeTrigger}
                              style={{
                                backgroundColor: "#c7c7c7",
                                color: "white",
                                textTransform: "none",
                              }}
                              variant="contained"
                              component="span"

                              // onClick={downloadDuplicates}
                            >
                              {" "}
                              {loaderDownloadTrig == true ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: loaderDownloadTrig
                                      ? "space-between"
                                      : "",
                                  }}
                                >
                                  <CircularProgress
                                    size="1rem"
                                    color="inherit"
                                    display={
                                      loaderDownloadTrig == true
                                        ? "true"
                                        : "false"
                                    }
                                  />
                                </div>
                              ) : (
                                "Trigger"
                              )}
                            </Button>
                          ) : (
                            ""
                          )}

                          <Button
                            sx={{ ml: 1, width: "180px", height: "38px" }}
                            style={{
                              backgroundColor: "#FF6A0A",
                              color: "white",
                              textTransform: "none",
                            }}
                            variant="contained"
                            component="span"
                            disabled={table === "user" ? true : false}
                            startIcon={
                              <FileDownloadIcon
                                style={{
                                  display: loaderDownload ? "none" : "",
                                }}
                                fontSize="small"
                              />
                            }
                            // onClick={downloadDuplicates}
                          >
                            {" "}
                            {loaderDownload == true ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: loaderDownload
                                    ? "space-between"
                                    : "",
                                }}
                              >
                                <CircularProgress
                                  size="1rem"
                                  color="inherit"
                                  display={
                                    loaderDownload == true ? "true" : "false"
                                  }
                                />
                              </div>
                            ) : (
                              <CSVLink
                                data={rows}
                                filename={table + ".csv"}
                                style={{
                                  textDecoration: "none",
                                  color: "white",
                                }}
                              >
                                Download Data
                              </CSVLink>
                            )}
                          </Button>
                          {table !== "user" &&
                          table !== "approval" &&
                          table !== "templates" &&
                          table !== "yearquarter" &&
                          table !== "teams" &&
                          table !== "emails" ? (
                            <Button
                              sx={{ ml: 1, width: "250px", height: "38px" }}
                              style={{
                                backgroundColor: "#969199",
                                color: "white",
                                textTransform: "none",
                              }}
                              onClick={getbackuptabledata}
                              variant="contained"
                              component="span"
                              startIcon={
                                <FileDownloadIcon
                                  style={{
                                    display: loaderBackup ? "none" : "",
                                  }}
                                  fontSize="small"
                                />
                              }
                              // onClick={downloadDuplicates}
                            >
                              {" "}
                              {loaderBackup == true ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: loaderBackup
                                      ? "space-between"
                                      : "",
                                  }}
                                >
                                  <CircularProgress
                                    size="1rem"
                                    color="inherit"
                                    display={
                                      loaderBackup == true ? "true" : "false"
                                    }
                                  />
                                </div>
                              ) : (
                                "Download Backup Data"
                              )}
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </ThemeProvider>
          </div>
          {table === "approval" || table === "templates" ? (
            <div>
              <TableContainer sx={{ maxHeight: 490, overflow: "auto" }}>
                <Table
                  stickyHeader
                  sx={{ minWidth: 1050 }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "small"}
                >
                  <EnhancedTableHead
                    headCells={headcells}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                  />
                  <TableBody>
                    {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                    {stableSort(rows, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.name);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            //   hover
                            //   onClick={(event) => handleClick(event, row.name)}
                            //   role="checkbox"
                            //   aria-checked={isItemSelected}
                            //   tabIndex={-1}
                            key={row.id}
                            //   selected={isItemSelected}
                          >
                            {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                            {/* {row.map((object, i) => <TableCell align="right" obj={object} key={i} />)} */}

                            {/* {row.map(item => <TableCell align="right" key={item.id} name={item.name} />)}  */}
                            {Object.keys(row).map((key, idx) => (
                              // editingIndex === row.id ? (
                              //   <StyledTableCell align="left">
                              //     {key == "effective_start_date" ||
                              //     key == "effective_end_date" ? (
                              //       <div>
                              //         {key === "effective_start_date" ? (
                              //           <LocalizationProvider
                              //             dateAdapter={AdapterMoment}
                              //           >
                              //             <DatePicker
                              //               views={["day"]}
                              //               value={effStartDate}
                              //               format="yyyy-MM-dd"
                              //               onChange={(newValue) => {
                              //                 // console.log(newValue, "efftfadh");
                              //                 setEffStartDate(newValue);
                              //                 // inputChangeHandler(event, newValue, row.id, key)
                              //               }}
                              //               renderInput={(params) => (
                              //                 <TextField
                              //                   {...params}
                              //                   size="small"
                              //                   helperText={null}
                              //                 />
                              //               )}
                              //             />
                              //           </LocalizationProvider>
                              //         ) : (
                              //           <LocalizationProvider
                              //             dateAdapter={AdapterMoment}
                              //           >
                              //             <DatePicker
                              //               views={["day"]}
                              //               value={effEndDate}
                              //               onChange={(newValue) => {
                              //                 setEffendDate(newValue);
                              //                 // inputChangeHandler(event, newValue, row.id, key)
                              //               }}
                              //               renderInput={(params) => (
                              //                 <TextField
                              //                   {...params}
                              //                   size="small"
                              //                   helperText={null}
                              //                 />
                              //               )}
                              //             />
                              //           </LocalizationProvider>
                              //         )}
                              //       </div>
                              //     ) : (
                              //       <TextField
                              //         size="small"
                              //         key={row.id}
                              //         disabled={key === "id"}
                              //         style={{ width: "8rem" }}
                              //         onChange={(e) =>
                              //           inputChangeHandler(
                              //             e,
                              //             row[key],
                              //             row.id,
                              //             key
                              //           )
                              //         }
                              //         defaultValue={row[key]}
                              //       />
                              //     )}
                              //   </StyledTableCell>
                              // ) : (
                              //   <StyledTableCell
                              //     align="left"
                              //     key={idx}
                              //     style={{ width: "8rem" }}
                              //   >
                              //     {key == "effective_start_date" ||
                              //     key == "effective_end_date"
                              //       ? moment(row[key]).format("L")
                              //       : row[key]}
                              //   </StyledTableCell>
                              // )
                              <StyledTableCell
                              align="left"
                              key={idx}
                              style={{ width: "8rem" }}
                            >
                              {/* {&& TabValue === 0 &&  row["status"] === "approved" ? <button>status change</button> :""} */}
                              {/* {table == "approval" ? (
                                <>
                                  {" "}
                                  {TabValue === 0 ? (
                                    <>
                                      {key == "update_status" ? (
                                        row["status"] == "approved" ? (
                                          <button>status change</button>
                                        ) : (
                                          row[key]
                                        )
                                      ) : (
                                        row[key]
                                      )}{" "}
                                    </>
                                  ) : (
                                    <>
                                      {key == "update_status" ? (
                                        row["status"] == "success" ? (
                                          <button>status change</button>
                                        ) : (
                                          row[key]
                                        )
                                      ) : (
                                        row[key]
                                      )}{" "}
                                    </>
                                  )}
                                </>
                              ) : (
                                row[key]
                              )} */}
                              {row[key]}
                            </StyledTableCell>
                             
                            ))}
 <StyledTableCell
                                align="left"
                                key={row.id}
                                style={{ width: "8rem" }}
                              >
                                {/* {&& TabValue === 0 &&  row["status"] === "approved" ? <button>status change</button> :""} */}
                                {table == "approval" ? (
                                  <>
                                    {" "}
                                    {TabValue === 0 ? (
                                      <>
                                     {  row["status"] == "approved" ? 

<div>  {loaderStatusApproval == true && changedStatusId === row.id  ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={loaderStatusApproval == true ? "true" : "false"}
                  />
                </div>):<button className="status-change-btn" onClick={()=>handleStatusApproval(row)}>update status</button>}     </div>
                                      
                                           : (
                                           ""
                                          )}
                                        
                                      </>
                                    ) : (
                                      <>
                                       { row["status"] == "success" ? (
                                         <div>  {loaderStatusRBMApproval == true && changedStatusRBMId === row.id ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <CircularProgress
                                              size="1rem"
                                              color="inherit"
                                              display={loaderStatusRBMApproval == true ? "true" : "false"}
                                            />
                                          </div>):<button className="status-change-btn" onClick={()=>handleStatusRBMApproval(row)}>update status</button>}     </div>
                                          ) : (
                                            ""
                                          )
                      }
                                      </>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </StyledTableCell>
                        
                            {/* <TableCell
                        component="th"
                        
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                      <TableCell align="right">{row.fat}</TableCell>
                      <TableCell align="right">{row.carbs}</TableCell>
                      <TableCell align="right">{row.protein}</TableCell> */}
                            {/* {editingIndex === row.id ? (
                              <StyledTableCell align="left">
                                {editReady === true ? (
                                  ""
                                ) : (
                                  <CloseIcon
                                    sx={{ marginRight: "10px" }}
                                    onClick={(event) =>
                                      handleEditClose(event, row.id)
                                    }
                                  />
                                )}
                                {editReady === true ? (
                                  <CircularProgress
                                    size="1.5rem"
                                    color="success"
                                    display={editReady.toString()}
                                  />
                                ) : (
                                  <DoneIcon
                                    onClick={(event) =>
                                      handleEditSave(event, row.id)
                                    }
                                  />
                                )}
                              </StyledTableCell>
                            ) : (
                              <StyledTableCell align="left">
                                <ModeEditOutlineIcon
                                  sx={{ marginRight: "10px" }}
                                  onClick={(event) => handleEdit(event, row)}
                                />
                                <DeleteIcon
                                  onClick={(event) =>
                                    handleDelete(event, row.id)
                                  }
                                />
                              </StyledTableCell>
                            )} */}
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={4} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          ) : (
            <div>
              {table === "emails" ? (
                <div>
                  <TableContainer sx={{ maxHeight: 490, overflow: "auto" }}>
                    <Table
                      stickyHeader
                      sx={{ minWidth: 1050 }}
                      aria-labelledby="tableTitle"
                      size={dense ? "small" : "small"}
                    >
                      <EnhancedTableHead
                        headCells={headcells}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                      />
                      <TableBody>
                        {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                        {stableSort(rows, getComparator(order, orderBy))
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            const isItemSelected = isSelected(row.name);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                //   hover
                                //   onClick={(event) => handleClick(event, row.name)}
                                //   role="checkbox"
                                //   aria-checked={isItemSelected}
                                //   tabIndex={-1}
                                key={row.id}
                                //   selected={isItemSelected}
                              >
                                {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                                {/* {row.map((object, i) => <TableCell align="right" obj={object} key={i} />)} */}
                                {/* {row.map(item => <TableCell align="right" key={item.id} name={item.name} />)}  */}
                                {Object.keys(row).map((key, idx) =>
                                  editingIndex === row.id ? (
                                    <StyledTableCell align="left">
                                      {key == "effective_start_date" ||
                                      key == "effective_end_date" ? (
                                        <div>
                                          {key === "effective_start_date"
                                            ? ""
                                            : ""}
                                        </div>
                                      ) : (
                                        <div>
                                          {key === "body" ||
                                          key === "subject" ||
                                          key === "cc" ? (
                                            <TextField
                                              size="small"
                                              multiline
                                              rows={10}
                                              key={row.id}
                                              disabled={key === "id"}
                                              style={{ width: "26rem" }}
                                              onChange={(e) =>
                                                inputChangeHandler(
                                                  e,
                                                  row[key],
                                                  row.id,
                                                  key
                                                )
                                              }
                                              defaultValue={row[key]}
                                            />
                                          ) : (
                                            <TextField
                                              size="small"
                                              key={row.id}
                                              disabled={key === "id"}
                                              style={{ width: "8rem" }}
                                              onChange={(e) =>
                                                inputChangeHandler(
                                                  e,
                                                  row[key],
                                                  row.id,
                                                  key
                                                )
                                              }
                                              defaultValue={row[key]}
                                            />
                                          )}
                                        </div>
                                      )}
                                    </StyledTableCell>
                                  ) : (
                                    <StyledTableCell
                                      align="left"
                                      key={idx}
                                      style={{
                                        width:
                                          key === "body" || key === "cc"
                                            ? "36rem"
                                            : "8rem",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width:
                                            key === "body" ? "36rem" : "8rem",
                                        }}
                                      >
                                        {row[key]}
                                      </div>
                                    </StyledTableCell>
                                  )
                                )}
                                {/* <TableCell
                        component="th"
                        
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                      <TableCell align="right">{row.fat}</TableCell>
                      <TableCell align="right">{row.carbs}</TableCell>
                      <TableCell align="right">{row.protein}</TableCell> */}
                                {editingIndex === row.id ? (
                                  <StyledTableCell align="left">
                                    {editReady === true ? (
                                      ""
                                    ) : (
                                      <CloseIcon
                                        sx={{ marginRight: "10px" }}
                                        onClick={(event) =>
                                          handleEditClose(event, row.id)
                                        }
                                      />
                                    )}
                                    {editReady === true ? (
                                      <CircularProgress
                                        size="1.5rem"
                                        color="success"
                                        display={editReady.toString()}
                                      />
                                    ) : (
                                      <DoneIcon
                                        onClick={(event) =>
                                          handleEditSave(event, row.id)
                                        }
                                      />
                                    )}
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell align="left">
                                    <ModeEditOutlineIcon
                                      sx={{ marginRight: "10px" }}
                                      onClick={(event) =>
                                        handleEdit(event, row)
                                      }
                                    />
                                    <DeleteIcon
                                      onClick={(event) =>
                                        handleDelete(event, row.id)
                                      }
                                    />
                                  </StyledTableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={4} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              ) : table === "teams" ? (
                <div>
                  <TableContainer sx={{ maxHeight: 490, overflow: "auto" }}>
                    <Table
                      stickyHeader
                      sx={{ minWidth: 1050 }}
                      aria-labelledby="tableTitle"
                      size={dense ? "small" : "small"}
                    >
                      <EnhancedTableHead
                        headCells={headcells}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                      />
                      <TableBody>
                        {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                        {stableSort(rows, getComparator(order, orderBy))
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            const isItemSelected = isSelected(row.name);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                //   hover
                                //   onClick={(event) => handleClick(event, row.name)}
                                //   role="checkbox"
                                //   aria-checked={isItemSelected}
                                //   tabIndex={-1}
                                key={row.id}
                                //   selected={isItemSelected}
                              >
                                {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                                {/* {row.map((object, i) => <TableCell align="right" obj={object} key={i} />)} */}
                                {/* {row.map(item => <TableCell align="right" key={item.id} name={item.name} />)}  */}
                                {Object.keys(row).map((key, idx) => (
                                  // editingIndex === row.id ? (
                                  //   <StyledTableCell align="left">
                                  //     {key == "effective_start_date" ||
                                  //     key == "effective_end_date" ? (
                                  //       <div>
                                  //         {key === "effective_start_date" ? (
                                  //           <LocalizationProvider
                                  //             dateAdapter={AdapterMoment}
                                  //           >
                                  //             <DatePicker
                                  //               views={["day"]}
                                  //               value={effStartDate}
                                  //               format="yyyy-MM-dd"
                                  //               onChange={(newValue) => {
                                  //                 // console.log(newValue, "efftfadh");
                                  //                 setEffStartDate(newValue);
                                  //                 // inputChangeHandler(event, newValue, row.id, key)
                                  //               }}
                                  //               renderInput={(params) => (
                                  //                 <TextField
                                  //                   {...params}
                                  //                   size="small"
                                  //                   helperText={null}
                                  //                 />
                                  //               )}
                                  //             />
                                  //           </LocalizationProvider>
                                  //         ) : (
                                  //           <LocalizationProvider
                                  //             dateAdapter={AdapterMoment}
                                  //           >
                                  //             <DatePicker
                                  //               views={["day"]}
                                  //               value={effEndDate}
                                  //               onChange={(newValue) => {
                                  //                 setEffendDate(newValue);
                                  //                 // inputChangeHandler(event, newValue, row.id, key)
                                  //               }}
                                  //               renderInput={(params) => (
                                  //                 <TextField
                                  //                   {...params}
                                  //                   size="small"
                                  //                   helperText={null}
                                  //                 />
                                  //               )}
                                  //             />
                                  //           </LocalizationProvider>
                                  //         )}
                                  //       </div>
                                  //     ) : (
                                  //       <TextField
                                  //         size="small"
                                  //         key={row.id}
                                  //         disabled={key === "id"}
                                  //         style={{ width: "8rem" }}
                                  //         onChange={(e) =>
                                  //           inputChangeHandler(
                                  //             e,
                                  //             row[key],
                                  //             row.id,
                                  //             key
                                  //           )
                                  //         }
                                  //         defaultValue={row[key]}
                                  //       />
                                  //     )}
                                  //   </StyledTableCell>
                                  // ) : (
                                  //   <StyledTableCell
                                  //     align="left"
                                  //     key={idx}
                                  //     style={{ width: "8rem" }}
                                  //   >
                                  //     {key == "effective_start_date" ||
                                  //     key == "effective_end_date"
                                  //       ? moment(row[key]).format("L")
                                  //       : row[key]}
                                  //   </StyledTableCell>
                                  // )
                                  <StyledTableCell
                                    align="left"
                                    key={idx}
                                    style={{ width: "8rem" }}
                                  >
                                    {key === "stitched_data" ||
                                    key === "adjusted_data" ||
                                    key === "disseminated_data" ? (
                                      <div>
                                        {key === "stitched_data" ? (
                                          <button
                                            key={row.id}
                                            className="submit-btn-teams"
                                            onClick={(event) =>
                                              handleGenerate(event, key, row)
                                            }
                                          >
                                            {(loaderTeams == true) &
                                            (selectedEditRow.id === row.id) ? (
                                              <div
                                                key={row.id}
                                                style={{
                                                  width: "120px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <CircularProgress
                                                  size="1rem"
                                                  color="inherit"
                                                  display={
                                                    loaderTeams == true
                                                      ? "true"
                                                      : "false"
                                                  }
                                                />
                                              </div>
                                            ) : (
                                              "Generate " +
                                              key
                                                .replace("_", " ")
                                                .toLocaleLowerCase()
                                            )}
                                          </button>
                                        ) : (
                                          <div>
                                            {key === "adjusted_data" ? (
                                              <button
                                                button
                                                key={idx}
                                                className="submit-btn-teams"
                                                disabled={
                                                  row["stitched_data"] !==
                                                  "success"
                                                }
                                                onClick={(event) =>
                                                  handleGenerate(
                                                    event,
                                                    key,
                                                    row
                                                  )
                                                }
                                              >
                                                {(loaderTeams1 === true) &
                                                (selectedEditRow.id ===
                                                  row.id) ? (
                                                  <div
                                                    key={row.id}
                                                    style={{
                                                      width: "120px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <CircularProgress
                                                      size="1rem"
                                                      color="inherit"
                                                      display={
                                                        loaderTeams1 === true
                                                          ? "true"
                                                          : "false"
                                                      }
                                                    />
                                                  </div>
                                                ) : (
                                                  "Generate " +
                                                  key
                                                    .replace("_", " ")
                                                    .toLocaleLowerCase()
                                                )}
                                              </button>
                                            ) : (
                                              <button
                                                button
                                                key={idx}
                                                className="submit-btn-teams"
                                                disabled={
                                                  row["adjusted_data"] !==
                                                  "success"
                                                }
                                                onClick={(event) =>
                                                  handleGenerate(
                                                    event,
                                                    key,
                                                    row
                                                  )
                                                }
                                              >
                                                {(loaderTeams2 === true) &
                                                (selectedEditRow.id ===
                                                  row.id) ? (
                                                  <div
                                                    key={row.id}
                                                    style={{
                                                      width: "120px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <CircularProgress
                                                      size="1rem"
                                                      color="inherit"
                                                      display={
                                                        loaderTeams2 === true
                                                          ? "true"
                                                          : "false"
                                                      }
                                                    />
                                                  </div>
                                                ) : (
                                                  "Generate " +
                                                  key
                                                    .replace("_", " ")
                                                    .toLocaleLowerCase()
                                                )}
                                              </button>
                                              
                                            )}
                                            
                                          </div>
                                          
                                        )}
                                        
                                      </div>
                                    ) : key === "date" ? (
                                      moment(row[key]).format("L")
                                    ) : (
                                      row[key]
                                    )}
                                    
                                  </StyledTableCell>
                                  
                                ))}
                                <StyledTableCell align="left">
                                  <button className="submit-btn-teams" onClick={handleOpenModal}>
                                    Upload Team Data
                                  </button>
                                </StyledTableCell>
                                <Dialog
                                fullWidth
                                maxWidth="lg"
                                aria-labelledby="draggable-dialog-title"
                                open={openModal}
                                onClose={handleCloseModal}
                              >
                                <DialogTitle>Select Teams</DialogTitle>
                                <DialogContent>
                                  {/* Multi-Select for Teams */}
                                  <FormControl fullWidth style={{ marginBottom: "1rem" }}>
                                    <InputLabel>Select Teams</InputLabel>
                                    <Select multiple value={selectedTeams} onChange={handleChangeTeams} renderValue={(selected) => selected.join(", ")}>
                                      {teams.map((team) => (
                                        <MenuItem key={team} value={team}>
                                          {team}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>

                                  {/* Single Select for Source Name */}
                                  <FormControl fullWidth>
                                    <InputLabel>Select Source</InputLabel>
                                    <Select value={selectedSource} onChange={handleSourceChange}>
                                      {sources.map((source) => (
                                        <MenuItem key={source} value={source}>
                                          {source}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </DialogContent>

                                <DialogActions>
                                  <Button onClick={handleCloseModal} color="secondary">Cancel</Button>
                                  <Button onClick={handleApiCall} color="primary" disabled={!selectedSource || selectedTeams.length === 0 || loadingAPI}>
                                    {loadingAPI ? <CircularProgress size="1.5rem" color="inherit" /> : "Submit"}
                                  </Button>
                                </DialogActions>
                              </Dialog>
                                {/* <TableCell
                        component="th"
                        
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                      <TableCell align="right">{row.fat}</TableCell>
                      <TableCell align="right">{row.carbs}</TableCell>
                      <TableCell align="right">{row.protein}</TableCell> */}
                                {/* {editingIndex === row.id ? (
                              <StyledTableCell align="left">
                                {editReady === true ? (
                                  ""
                                ) : (
                                  <CloseIcon
                                    sx={{ marginRight: "10px" }}
                                    onClick={(event) =>
                                      handleEditClose(event, row.id)
                                    }
                                  />
                                )}
                                {editReady === true ? (
                                  <CircularProgress
                                    size="1.5rem"
                                    color="success"
                                    display={editReady.toString()}
                                  />
                                ) : (
                                  <DoneIcon
                                    onClick={(event) =>
                                      handleEditSave(event, row.id)
                                    }
                                  />
                                )}
                              </StyledTableCell>
                            ) : (
                              <StyledTableCell align="left">
                                <ModeEditOutlineIcon
                                  sx={{ marginRight: "10px" }}
                                  onClick={(event) => handleEdit(event, row)}
                                />
                                <DeleteIcon
                                  onClick={(event) =>
                                    handleDelete(event, row.id)
                                  }
                                />
                              </StyledTableCell>
                            )} */}
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={4} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              ) : (
                <div>
                  <TableContainer sx={{ maxHeight: 490, overflow: "auto" }}>
                    <Table
                      stickyHeader
                      sx={{ minWidth: 1050 }}
                      aria-labelledby="tableTitle"
                      size={dense ? "small" : "small"}
                    >
                      <EnhancedTableHead
                        headCells={headcells}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                      />
                      <TableBody>
                        {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                        {stableSort(rows, getComparator(order, orderBy))
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            const isItemSelected = isSelected(row.name);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                //   hover
                                //   onClick={(event) => handleClick(event, row.name)}
                                //   role="checkbox"
                                //   aria-checked={isItemSelected}
                                //   tabIndex={-1}
                                key={row.id}
                                //   selected={isItemSelected}
                              >
                                {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </TableCell> */}
                                {/* {row.map((object, i) => <TableCell align="right" obj={object} key={i} />)} */}
                                {/* {row.map(item => <TableCell align="right" key={item.id} name={item.name} />)}  */}
                                {Object.keys(row).map((key, idx) =>
                                  editingIndex === row.id ? (
                                    <StyledTableCell align="left">
                                      {key == "effective_start_date" ||
                                      key == "effective_end_date" ? (
                                        <div>
                                          {key === "effective_start_date" ? (
                                            <LocalizationProvider
                                              dateAdapter={AdapterMoment}
                                            >
                                              <DatePicker
                                                views={["day"]}
                                                value={effStartDate}
                                                format="yyyy-MM-dd"
                                                onChange={(newValue) => {
                                                  // console.log(newValue, "efftfadh");
                                                  setEffStartDate(newValue);
                                                  // inputChangeHandler(event, newValue, row.id, key)
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    size="small"
                                                    helperText={null}
                                                  />
                                                )}
                                              />
                                            </LocalizationProvider>
                                          ) : (
                                            <LocalizationProvider
                                              dateAdapter={AdapterMoment}
                                            >
                                              <DatePicker
                                                views={["day"]}
                                                value={effEndDate}
                                                onChange={(newValue) => {
                                                  setEffendDate(newValue);
                                                  // inputChangeHandler(event, newValue, row.id, key)
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    size="small"
                                                    helperText={null}
                                                  />
                                                )}
                                              />
                                            </LocalizationProvider>
                                          )}
                                        </div>
                                      ) : (
                                        <TextField
                                          size="small"
                                          key={row.id}
                                          disabled={key === "id"}
                                          style={{ width: "8rem" }}
                                          onChange={(e) =>
                                            inputChangeHandler(
                                              e,
                                              row[key],
                                              row.id,
                                              key
                                            )
                                          }
                                          defaultValue={row[key]}
                                        />
                                      )}
                                    </StyledTableCell>
                                  ) : (
                                    <StyledTableCell
                                      align="left"
                                      key={idx}
                                      style={{ width: "8rem" }}
                                    >
                                      {key == "effective_start_date" ||
                                      key == "effective_end_date"
                                        ? moment(row[key]).format("L")
                                        : row[key]}
                                    </StyledTableCell>
                                  )
                                )}
                                {/* <TableCell
                        component="th"
                        
                        id={labelId}
                        scope="row"
                        align="left"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.calories}</TableCell>
                      <TableCell align="right">{row.fat}</TableCell>
                      <TableCell align="right">{row.carbs}</TableCell>
                      <TableCell align="right">{row.protein}</TableCell> */}
                                {editingIndex === row.id ? (
                                  <StyledTableCell align="left">
                                    {editReady === true ? (
                                      ""
                                    ) : (
                                      <CloseIcon
                                        sx={{ marginRight: "10px" }}
                                        onClick={(event) =>
                                          handleEditClose(event, row.id)
                                        }
                                      />
                                    )}
                                    {editReady === true ? (
                                      <CircularProgress
                                        size="1.5rem"
                                        color="success"
                                        display={editReady.toString()}
                                      />
                                    ) : (
                                      <DoneIcon
                                        onClick={(event) =>
                                          handleEditSave(event, row.id)
                                        }
                                      />
                                    )}
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell align="left">
                                    <ModeEditOutlineIcon
                                      sx={{ marginRight: "10px" }}
                                      onClick={(event) =>
                                        handleEdit(event, row)
                                      }
                                    />
                                    <DeleteIcon
                                      onClick={(event) =>
                                        handleDelete(event, row.id)
                                      }
                                    />
                                  </StyledTableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={4} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
            </div>
          )}
        </Paper>
      )}
      <div>
        {/* <Button variant="outlined" onClick={handleClickOpenDel}>
        Open draggable dialog
      </Button> */}
        <Dialog
          open={openDel}
          onClose={handleCloseDel}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Delete
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "32px",
              }}
              autoFocus
              onClick={handleCloseDel}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#fd7d21",
                textTransform: "none",
                color: "white",
                height: "32px",
              }}
              onClick={handleClickOpenDel}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openUser}
          onClose={handleCloseUser}
          fullWidth
          maxWidth="lg"
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle
            style={{
              cursor: "move",
              display: "flex",
              justifyContent: "space-between",
            }}
            id="draggable-dialog-title"
          >
            <span>Create User</span>
            <div>
              <Button
                style={{
                  backgroundColor: "#e5e5e5",
                  color: "black",
                  height: "35px",
                  textTransform: "none",
                  fontSize: "13px",
                }}
                variant="contained"
                component="label"
              >
                <AttachmentIcon size="small" style={{ marginRight: "5px" }} />
                {isFilePicked ? selectedFileName : "Select File"}
                <input
                  onChange={changeHandlerUserBulk}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                  hidden
                  accept="/*"
                  type="file"
                />
              </Button>
              <LoadingButton
                onClick={UploadFileUserBulk}
                loading={loaderUpload}
                variant="contained"
                style={{
                  height: "35px",
                  marginLeft: "10px",
                  backgroundColor: "#e5e5e5",
                  textTransform: "none",
                  color: "black",
                }}
              >
                <FileUploadIcon
                  style={{ display: loaderUpload ? "none" : "" }}
                  fontSize="small"
                />
                {loaderUpload ? "" : "Upload"}
              </LoadingButton>
              {duplicates == true ? (
                <Button
                  sx={{ ml: 1, width: "180px", height: "35px" }}
                  style={{
                    backgroundColor: "#FF6A0A",
                    color: "white",
                    textTransform: "none",
                  }}
                  variant="contained"
                  component="span"
                  onClick={downloadDuplicates}
                  startIcon={<FileDownloadIcon fontSize="small" />}
                  // onClick={downloadDuplicates}
                >
                  {loaderDownloadDup == true ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: loaderDownloadDup
                          ? "space-between"
                          : "",
                      }}
                    >
                      <CircularProgress
                        size="1rem"
                        color="inherit"
                        display={loaderDownloadDup == true ? "true" : "false"}
                      />
                    </div>
                  ) : (
                    "Duplicates"
                  )}
                </Button>
              ) : (
                ""
              )}
            </div>
          </DialogTitle>

          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                marginTop: "10px",
              }}
            >
              {Object.keys(newUser).map((key, idx) => (
                <>
                  {key === "role" ? (
                    <>
                      <FormControl sx={{ m: 1, minWidth: 345 }} size="small">
                        <InputLabel id="demo-select-small">Role</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={newUserRole}
                          label="Role"
                          size="small"
                          onChange={(e) => onchangeUser(e, key)}
                        >
                          <MenuItem value={"ADMIN"}>ADMIN</MenuItem>
                          <MenuItem value={"BUH"}>BUH</MenuItem>
                          <MenuItem value={"RBM"}>RBM</MenuItem>
                          <MenuItem value={"ABM"}>ABM</MenuItem>
                          <MenuItem value={"REPHQ"}>REPHQ</MenuItem>
                          <MenuItem value={"COMMERCIALHEAD"}>
                            COMMERCIALHEAD
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  ) : (
                    <TextField
                      // error={exist}
                      key={key}
                      onChange={(e) => onchangeUser(e, key)}
                      id="filled-error-helper-text"
                      label={key.replace("_", " ")}
                      defalutValue={newUser[key]}
                      // helperText={exist?errormsg:""}
                      variant="outlined"
                      size="small"
                      sx={{ width: "30%", margin: "10px" }}
                    />
                  )}
                </>
              ))}
            </div>
            {/* <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "32px",
              }}
              onClick={handleCloseUser}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#fd7d21",
                textTransform: "none",
                color: "white",
                height: "32px",
              }}
              autoFocus
              onClick={handleClickSaveUser}
            >
              {LoaderSaveUser == true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={LoaderSaveUser == true ? "true" : "false"}
                  />
                </div>
              ) : (
                <span>Save</span>
              )}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openTriggerUp}
          onClose={handleCloseTriggerUp}
          fullWidth
          maxWidth="md"
          aria-labelledby="draggable-dialog-title1"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title1">
            Trigger
          </DialogTitle>
          <DialogContent>
            <FormControl sx={{ m: 3, width: 400 }}>
              <InputLabel
                style={{
                  marginTop: selectedTrigger.length > 0 ? "0px" : "-8px",
                }}
                id="mutiple-select-label"
              >
                Select Teams
              </InputLabel>
              <Select
                labelId="mutiple-select-label"
                multiple
                label="Select Teams"
                size="small"
                value={selectedTrigger}
                onChange={handleChangeTrigger}
                renderValue={(selectedTrigger) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selectedTrigger.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
                style={{ width: "400px" }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                  classes={{
                    root: isAllSelected ? classes.selectedAll : "",
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      classes={{ indeterminate: classes.indeterminateColor }}
                      checked={isAllSelected}
                      indeterminate={
                        selectedTrigger.length > 0 &&
                        selectedTrigger.length < options.length
                      }
                    />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.selectAllText }}
                    primary="Select All"
                  />
                </MenuItem>
                {options.map((option) => (
                  <MenuItem key={option} value={option}>
                    <ListItemIcon>
                      <Checkbox
                        checked={selectedTrigger.indexOf(option) > -1}
                      />
                    </ListItemIcon>
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              sx={{
                ml: 1,
                mt: 3,
                width: "180px",
                height: selectedTrigger.length > 0 ? "46px" : "38px",
              }}
              onClick={MakeTriggerWithTeams}
              style={{
                backgroundColor: "#c7c7c7",
                color: "white",
                textTransform: "none",
              }}
              variant="contained"
              component="span"

              // onClick={downloadDuplicates}
            >
              {" "}
              {loaderDownloadTrig == true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: loaderDownloadTrig ? "space-between" : "",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={loaderDownloadTrig == true ? "true" : "false"}
                  />
                </div>
              ) : (
                "Trigger"
              )}
            </Button>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "32px",
              }}
              autoFocus
              onClick={handleCloseTriggerUp}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openReset}
          onClose={handleCloseReset}
          fullWidth
          maxWidth="lg"
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            RESET
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <FormControl sx={{ width: 300, marginRight: "5px" }}>
                  <InputLabel
                    style={{
                      marginTop:
                        selectedOptionsTeams.length > 0 ? "0px" : "-8px",
                    }}
                    id="demo-multiple-chip-label1"
                  >
                    Teamcode
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label1"
                    id="demo-multiple-chip"
                    size="small"
                    value={selectedOptionsTeams}
                    onChange={onchangeReset}
                    input={
                      <OutlinedInput id="select-multiple-chip" label="Chip" />
                    }
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selectedOptionsTeams.map((value) => (
                          <Chip size="small" key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps1}
                  >
                    {teamsListReset.map((name) => (
                      <MenuItem
                        key={name}
                        value={name}
                        style={getStyles(name, selectedOptionsTeams, theme)}
                      >
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <div style={{ marginRight: "5px", width: "42%" }}>
                  <MultiSelectRBM
                    items={rbmcodesListReset}
                    getOptionLabel={getOptionLabelRbm}
                    getOptionDisabled={getOptionDisabled}
                    selectedValues={selectedOptionsRbm}
                    label="RBM Code"
                    selectAllLabel="Select All"
                    onToggleOption={handleToggleOptionRbm}
                    onClearOptions={handleClearOptionsRbm}
                    onSelectAll={handleSelectAllRbm}
                  />
                </div>
                <div style={{ marginRight: "5px", width: "42%" }}>
                  <MultiSelectABM
                    items={abmcodesListReset}
                    getOptionLabel={getOptionLabelAbm}
                    getOptionDisabled={getOptionDisabled}
                    selectedValues={selectedOptionsAbm}
                    label="ABM Code"
                    selectAllLabel="Select All"
                    onToggleOption={handleToggleOptionAbm}
                    onClearOptions={handleClearOptionsAbm}
                    onSelectAll={handleSelectAllAbm}
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ marginRight: "5px", width: "42%" }}>
                  <MultiSelectREPHQ
                    items={repcodesListReset}
                    getOptionLabel={getOptionLabelRephq}
                    getOptionDisabled={getOptionDisabled}
                    selectedValues={selectedOptionsRephq}
                    label="REPHQ Code"
                    selectAllLabel="Select All"
                    onToggleOption={handleToggleOptionRephq}
                    onClearOptions={handleClearOptionsRephq}
                    onSelectAll={handleSelectAllRephq}
                  />
                </div>
                <div style={{ marginRight: "5px", width: "30%" }}>
                  <MultiSelectQuarter
                    items={quartersListReset}
                    getOptionLabel={getOptionLabelQuarter}
                    getOptionDisabled={getOptionDisabled}
                    selectedValues={selectedOptionsQuarter}
                    label="Quarter"
                    selectAllLabel="Select All"
                    onToggleOption={handleToggleOptionQuarter}
                    onClearOptions={handleClearOptionsQuarter}
                    onSelectAll={handleSelectAllQuarter}
                  />
                </div>
                <div style={{ marginRight: "5px", width: "30%" }}>
                  <MultiSelectYear
                    items={yearsListReset}
                    getOptionLabel={getOptionLabelYear}
                    getOptionDisabled={getOptionDisabled}
                    selectedValues={selectedOptionsYear}
                    label="Year"
                    selectAllLabel="Select All"
                    onToggleOption={handleToggleOptionYear}
                    onClearOptions={handleClearOptionsYear}
                    onSelectAll={handleSelectAllYear}
                  />
                </div>
              </div>
              {/* <Autocomplete
                freeSolo
                
                id="free-solo-2-demo"
                disableClearable
                sx={{ width: "32%" }}
                fullWidth={true}
                multiple
                options={rbmcodesListReset.map((option) => option.rbmcode)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    label="RBM name"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
              /> */}
              {/* <TextField
                error={exist}
                onChange={onchangeEmali}
                id="filled-error-helper-text"
                label="Email"
                helperText={exist ? errormsg : ""}
                variant="outlined"
                size="small"
                sx={{ width: "32%" }}
              /> */}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                backgroundColor: "#E5E5E5",
                textTransform: "none",
                color: "black",
                height: "42px",
                width: "10%",
              }}
              onClick={handleCloseReset}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#fd7d21",
                textTransform: "none",
                color: "white",
                height: "42px",
                width: "10%",
              }}
              autoFocus
              onClick={handleResetSubmit}
            >
              {loaderReset == true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size="1rem"
                    color="inherit"
                    display={loaderReset == true ? "true" : "false"}
                  />
                </div>
              ) : (
                <span>RESET</span>
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
    </Box>
  );
}
